export default {
  // Navigation
  'nav.home': 'Inicio',
  'nav.about': 'Acerca de',
  'nav.features': 'Características',
  'nav.partners': 'Socios',
  'nav.testimonials': 'Testimonios',
  'nav.login': 'Iniciar sesión',
  'nav.portal': 'Portal de Miembros',
  
  // Hero
  'hero.title': 'Aprende. Gana. Compra. Canjea.',
  'hero.subtitle': 'Transforma tu viaje de aprendizaje en recompensas con HoneyMoneyUnits (HMU)',
  'hero.cta.primary': 'Comenzar a Ganar HMU',
  'hero.cta.secondary': 'Saber Más',
  
  // Stats
  'stats.activeUsers': 'Usuarios Activos',
  'stats.hmuEarned': 'HMU Ganados',
  'stats.partners': 'Marcas Asociadas',
  'stats.rewards': 'Recompensas Canjeadas',
  
  // Features
  'features.title': 'Cómo Funciona HoneyJar',
  'features.learn.title': 'Aprende',
  'features.learn.desc': 'Completa módulos educativos y gana HMU',
  'features.earn.title': 'Gana',
  'features.earn.desc': 'Interactúa con marcas asociadas y acumula puntos',
  'features.shop.title': 'Compra',
  'features.shop.desc': 'Explora mercancía exclusiva y ofertas de socios',
  'features.redeem.title': 'Canjea',
  'features.redeem.desc': 'Intercambia tus HMU por recompensas y productos',
  'features.levelup.title': 'Sube de Nivel',
  'features.levelup.desc': 'Desbloquea insignias, rachas y beneficios exclusivos',
  
  // Portal
  'portal.welcome': 'Bienvenido de nuevo',
  'portal.hmuBalance': 'Saldo HMU',
  'portal.tierProgress': 'Progreso de Nivel',
  'portal.currentStreak': 'Racha Actual',
  'portal.badges': 'Insignias Coleccionadas',
  'portal.activeMissions': 'Misiones Activas',
  'portal.partnerOffers': 'Ofertas de Socios',
  'portal.recommendations': 'Recomendaciones Personalizadas',
  
  // Missions
  'missions.title': 'Misiones',
  'missions.all': 'Todas',
  'missions.learning': 'Aprendizaje',
  'missions.affiliate': 'Afiliados',
  'missions.completed': 'Completadas',
  'missions.active': 'Misiones Activas',
  'missions.completedCount': 'Completadas',
  'missions.earned': 'HMUs Ganados',
  'missions.timeInvested': 'Tiempo Invertido',
  'missions.start': 'Iniciar Misión',
  'missions.continue': 'Continuar',
  'missions.completed.btn': 'Completada',
  'missions.referralBonus': 'Bono de Referido',
  'missions.streakBonus': 'Bono de Racha',
  
  // Rewards
  'rewards.title': 'Catálogo de Recompensas',
  'rewards.all': 'Todas',
  'rewards.bewear': 'B.E. Wear',
  'rewards.digital': 'Productos Digitales',
  'rewards.partner': 'Ofertas de Socios',
  'rewards.redeem': 'Canjear',
  'rewards.locked': 'Bloqueado',
  'rewards.earnCPV': 'Gana',
  'rewards.earnCCV': 'por conversión',
  'rewards.selectSize': 'Seleccionar Talla',
  
  // Auth
  'auth.login': 'Iniciar Sesión',
  'auth.register': 'Registrarse',
  'auth.email': 'Correo Electrónico',
  'auth.password': 'Contraseña',
  'auth.name': 'Nombre Completo',
  'auth.location': 'Ubicación',
  'auth.referralCode': 'Código de Referido (Opcional)',
  'auth.welcomeBonus': '¡Obtén 50 HMU de Bono de Bienvenida!',
  'auth.optIn.tracking': 'Acepto el seguimiento de actividad',
  'auth.optIn.notifications': 'Quiero recibir notificaciones',
  'auth.optIn.partnerOffers': 'Quiero recibir ofertas de socios',
  'auth.noAccount': '¿No tienes una cuenta?',
  'auth.hasAccount': '¿Ya tienes una cuenta?',
  'auth.signUp': 'Regístrate',
  'auth.signIn': 'Inicia sesión',
  
  // Footer
  'footer.tagline': 'Empoderando el aprendizaje a través de recompensas',
  'footer.company': 'Empresa',
  'footer.about': 'Acerca de Nosotros',
  'footer.careers': 'Carreras',
  'footer.press': 'Prensa',
  'footer.contact': 'Contacto',
  'footer.resources': 'Recursos',
  'footer.blog': 'Blog',
  'footer.help': 'Centro de Ayuda',
  'footer.faq': 'Preguntas Frecuentes',
  'footer.legal': 'Legal',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos de Servicio',
  'footer.compliance': 'Cumplimiento',
  'footer.rights': 'Todos los derechos reservados',
  'footer.owner': 'Bingham ENT Global Empire',
  
  // Common
  'common.currency': 'HMU',
  'common.days': 'días',
  'common.hours': 'horas',
  'common.minutes': 'minutos',
  'common.loading': 'Cargando...',
  'common.error': 'Ocurrió un error',
  'common.success': '¡Éxito!',
};